/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { StrictHttpResponse } from '../strict-http-response';
import { WeatherApiConfiguration } from '../weather-api-configuration';

import { ChangeActive1$Params, changeActive1 } from '../fn/agro-climatic-zone/change-active-1';
import { GetAgroClimaticZone$Params, getAgroClimaticZone } from '../fn/agro-climatic-zone/get-agro-climatic-zone';
import { GetAgroClimaticZones$Params, getAgroClimaticZones } from '../fn/agro-climatic-zone/get-agro-climatic-zones';
import { SaveAgroClimaticZone$Params, saveAgroClimaticZone } from '../fn/agro-climatic-zone/save-agro-climatic-zone';
import {
   UpdateAgroClimaticZone$Params,
   updateAgroClimaticZone
} from '../fn/agro-climatic-zone/update-agro-climatic-zone';
import { AgroClimaticZone } from '../models/agro-climatic-zone';

/**
 * Agro Climatic Zone API
 */
@Injectable({ providedIn: 'root' })
export class AgroClimaticZoneService extends BaseService {
   constructor(config: WeatherApiConfiguration, http: HttpClient) {
      super(config, http);
   }

   /** Path part for operation `getAgroClimaticZones()` */
   static readonly GetAgroClimaticZonesPath = '/api/weather/agro/climatic/zone';

   /**
    * This method provides access to the full `HttpResponse`, allowing access to response headers.
    * To access only the response body, use `getAgroClimaticZones()` instead.
    *
    * This method doesn't expect any request body.
    */
   getAgroClimaticZones$Response(
      params?: GetAgroClimaticZones$Params,
      context?: HttpContext
   ): Observable<StrictHttpResponse<AgroClimaticZone>> {
      return getAgroClimaticZones(this.http, this.rootUrl, params, context);
   }

   /**
    * This method provides access only to the response body.
    * To access the full response (for headers, for example), `getAgroClimaticZones$Response()` instead.
    *
    * This method doesn't expect any request body.
    */
   getAgroClimaticZones(params?: GetAgroClimaticZones$Params, context?: HttpContext): Observable<AgroClimaticZone> {
      return this.getAgroClimaticZones$Response(params, context).pipe(
         map((r: StrictHttpResponse<AgroClimaticZone>): AgroClimaticZone => r.body)
      );
   }

   /** Path part for operation `updateAgroClimaticZone()` */
   static readonly UpdateAgroClimaticZonePath = '/api/weather/agro/climatic/zone';

   /**
    * This method provides access to the full `HttpResponse`, allowing access to response headers.
    * To access only the response body, use `updateAgroClimaticZone()` instead.
    *
    * This method sends `application/json` and handles request body of type `application/json`.
    */
   updateAgroClimaticZone$Response(
      params: UpdateAgroClimaticZone$Params,
      context?: HttpContext
   ): Observable<StrictHttpResponse<AgroClimaticZone>> {
      return updateAgroClimaticZone(this.http, this.rootUrl, params, context);
   }

   /**
    * This method provides access only to the response body.
    * To access the full response (for headers, for example), `updateAgroClimaticZone$Response()` instead.
    *
    * This method sends `application/json` and handles request body of type `application/json`.
    */
   updateAgroClimaticZone(params: UpdateAgroClimaticZone$Params, context?: HttpContext): Observable<AgroClimaticZone> {
      return this.updateAgroClimaticZone$Response(params, context).pipe(
         map((r: StrictHttpResponse<AgroClimaticZone>): AgroClimaticZone => r.body)
      );
   }

   /** Path part for operation `saveAgroClimaticZone()` */
   static readonly SaveAgroClimaticZonePath = '/api/weather/agro/climatic/zone';

   /**
    * This method provides access to the full `HttpResponse`, allowing access to response headers.
    * To access only the response body, use `saveAgroClimaticZone()` instead.
    *
    * This method sends `application/json` and handles request body of type `application/json`.
    */
   saveAgroClimaticZone$Response(
      params: SaveAgroClimaticZone$Params,
      context?: HttpContext
   ): Observable<StrictHttpResponse<AgroClimaticZone>> {
      return saveAgroClimaticZone(this.http, this.rootUrl, params, context);
   }

   /**
    * This method provides access only to the response body.
    * To access the full response (for headers, for example), `saveAgroClimaticZone$Response()` instead.
    *
    * This method sends `application/json` and handles request body of type `application/json`.
    */
   saveAgroClimaticZone(params: SaveAgroClimaticZone$Params, context?: HttpContext): Observable<AgroClimaticZone> {
      return this.saveAgroClimaticZone$Response(params, context).pipe(
         map((r: StrictHttpResponse<AgroClimaticZone>): AgroClimaticZone => r.body)
      );
   }

   /** Path part for operation `getAgroClimaticZone()` */
   static readonly GetAgroClimaticZonePath = '/api/weather/agro/climatic/zone/{id}';

   /**
    * This method provides access to the full `HttpResponse`, allowing access to response headers.
    * To access only the response body, use `getAgroClimaticZone()` instead.
    *
    * This method doesn't expect any request body.
    */
   getAgroClimaticZone$Response(
      params: GetAgroClimaticZone$Params,
      context?: HttpContext
   ): Observable<StrictHttpResponse<AgroClimaticZone>> {
      return getAgroClimaticZone(this.http, this.rootUrl, params, context);
   }

   /**
    * This method provides access only to the response body.
    * To access the full response (for headers, for example), `getAgroClimaticZone$Response()` instead.
    *
    * This method doesn't expect any request body.
    */
   getAgroClimaticZone(params: GetAgroClimaticZone$Params, context?: HttpContext): Observable<AgroClimaticZone> {
      return this.getAgroClimaticZone$Response(params, context).pipe(
         map((r: StrictHttpResponse<AgroClimaticZone>): AgroClimaticZone => r.body)
      );
   }

   /** Path part for operation `changeActive1()` */
   static readonly ChangeActive1Path = '/api/weather/agro/climatic/zone/changeActive';

   /**
    * This method provides access to the full `HttpResponse`, allowing access to response headers.
    * To access only the response body, use `changeActive1()` instead.
    *
    * This method sends `application/json` and handles request body of type `application/json`.
    */
   changeActive1$Response(
      params: ChangeActive1$Params,
      context?: HttpContext
   ): Observable<StrictHttpResponse<AgroClimaticZone>> {
      return changeActive1(this.http, this.rootUrl, params, context);
   }

   /**
    * This method provides access only to the response body.
    * To access the full response (for headers, for example), `changeActive1$Response()` instead.
    *
    * This method sends `application/json` and handles request body of type `application/json`.
    */
   changeActive1(params: ChangeActive1$Params, context?: HttpContext): Observable<AgroClimaticZone> {
      return this.changeActive1$Response(params, context).pipe(
         map((r: StrictHttpResponse<AgroClimaticZone>): AgroClimaticZone => r.body)
      );
   }
}
